import { dashboardRevenuePaymentFilterActions } from '../../constants/filter';
import { asyncAction } from '../common';
import * as api from '../../api/revenueDashboard';
import { errorHandlerUnitsQueries } from './dashboards';

export const executeDashboardRevenue = (unit, executeId) =>
  asyncAction(
    'EXECUTE_DASHBOARD_REVENUE_QUERIES',
    api.executeDashboardRevenueQuery(unit, executeId),
    errorHandlerUnitsQueries(unit.id)
  );

export const executeDashboardComposeRevenue = (unit, executeId) =>
  asyncAction(
    'EXECUTE_DASHBOARD_REVENUE_QUERIES',
    api.executeDashboardComposeRevenueQueries(unit, executeId),
    errorHandlerUnitsQueries(unit.id)
  );

export const setRevenueType = (unitId, queryType) => ({
  type: 'DASHBOARD_CHANGE_REVENUE_QUERY_TYPE',
  unitId,
  queryType,
});

export const setRevenueGroupColumn = (unitId, groupColumn) => ({
  type: 'DASHBOARD_REVENUE_COMPOSE_SET_GROUP_COLUMN',
  unitId,
  groupColumn,
});

export const setRevenueColumnChartSorting = (unitId, sorting) => ({
  type: 'DASHBOARD_CHANGE_REVENUE_COLUMN_CHART_SORTING',
  unitId,
  sorting,
});

export const setRevenueSplitColumn = (unitId, splitColumn) => ({
  type: 'DASHBOARD_REVENUE_COMPOSE_SET_SPLIT_COLUMN',
  unitId,
  splitColumn,
});

export const assignTypeQuery = (unitId, queryType) => ({
  type: 'DASHBOARD_ASSIGN_REVENUE_TYPE_QUERY',
  unitId,
  queryType,
});

export const addFilterClause = (unitId) => ({
  type: dashboardRevenuePaymentFilterActions.ADD_FILTER_CLAUSE,
  unitId,
});

export const removeFilterClause = (unitId, id) => ({
  type: dashboardRevenuePaymentFilterActions.REMOVE_FILTER_CLAUSE,
  unitId,
  id,
});

export const setFilterVisibility = (unitId, value) => ({
  type: dashboardRevenuePaymentFilterActions.SET_FILTER_VISIBILITY,
  unitId,
  value,
});

export const removeFilter = (unitId) => ({
  type: dashboardRevenuePaymentFilterActions.REMOVE_FILTER,
  unitId,
});

export const setFilterClauseField = (unitId, id, field, type) => ({
  type: dashboardRevenuePaymentFilterActions.SET_FILTER_CLAUSE_FIELD,
  unitId,
  id,
  field,
  fieldType: type,
});

export const setFilterClauseValue = (unitId, id, value) => ({
  type: dashboardRevenuePaymentFilterActions.SET_FILTER_CLAUSE_VALUE,
  unitId,
  id,
  value,
});

export const setClausesConcatOperator = (unitId, value) => ({
  type: dashboardRevenuePaymentFilterActions.SET_CLAUSES_CONCAT_OPERATOR,
  unitId,
  value,
});

export const setFilterClauseOperator = (unitId, id, value, resetClauseValue) => ({
  type: dashboardRevenuePaymentFilterActions.SET_FILTER_CLAUSE_OPERATOR,
  unitId,
  id,
  value,
  resetClauseValue,
});

export const changeRevenueView = (unitId, view) => ({
  type: 'DASHBOARD_CHANGE_REVENUE_VIEW',
  unitId,
  view,
});

export const setAmountField = (unitId, amountField) => ({
  type: 'DASHBOARD_SET_AMOUNT_FIELD',
  unitId,
  amountField,
});

export const toggleRevenueCalcTotal = (unitId) => ({
  type: 'DASHBOARD_TOGGLE_REVENUE_CALC_TOTAL',
  unitId,
});

export const toggleRevenueTrendLine = (unitId) => ({
  type: 'DASHBOARD_TOGGLE_REVENUE_TREND_LINE',
  unitId,
});

export const toggleRevenueAverageLine = (unitId) => ({
  type: 'DASHBOARD_TOGGLE_REVENUE_AVERAGE_LINE',
  unitId,
});

export const toggleRevenueMedianLine = (unitId) => ({
  type: 'DASHBOARD_TOGGLE_REVENUE_MEDIAN_LINE',
  unitId,
});

export const toggleRevenueAdaptive = (unitId) => ({
  type: 'DASHBOARD_TOGGLE_REVENUE_ADAPTIVE',
  unitId,
});
